import { siteContent } from "../content";
const disclaimer = siteContent.disclaimer;

const Disclaimer = () => (
  <div className="leading-tight text-gray-800 mt-10 md:mt-16 rounded-md  text-xs pr-0 md:pr-20">
    <strong>{disclaimer.title}</strong>
    <div className="mt-2">
      <small dangerouslySetInnerHTML={{ __html: disclaimer.content }}></small>
    </div>
  </div>
);
export default Disclaimer;
